import AddToCartFooter from './AddToCartFooter';

export default AddToCartFooter;
